import { render, staticRenderFns } from "./changelog-link.vue?vue&type=template&id=210188ee&"
import script from "./changelog-link.vue?vue&type=script&lang=ts&"
export * from "./changelog-link.vue?vue&type=script&lang=ts&"
import style0 from "./changelog-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports